export default "-- ClickBench Q20\nselect count(*)\nfrom hits\nwhere url like '%google%';";